"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const immer_1 = require("immer");
const getContent_1 = require("../helpers/getContent");
const getContentType_1 = require("../helpers/getContentType");
const getTimeSpentEvent_1 = require("../helpers/getEvent/getTimeSpentEvent");
const getState_1 = require("../helpers/getState");
const setStartedOn_1 = tslib_1.__importDefault(require("./helpers/setStartedOn"));
function applyAddTimeCommand(command, user, content, states) {
    const { contentId, userId, timeSpent, timeStamp, startTimestamp } = command;
    const events = [];
    const updatedStates = immer_1.produce(states, draftStates => {
        const state = getState_1.getStateByContentIdUserId(draftStates, contentId, userId);
        if (startTimestamp) {
            state.startTimestamp = startTimestamp;
        }
        if (state.timeSpent === 0 && timeSpent > 0) {
            setStartedOn_1.default(state, timeStamp);
        }
        state.lastAccessedOn = timeStamp;
        const currentContent = getContent_1.getContentByContentId(content, contentId);
        const currentlyAvailableTimeSpent = 3 * (currentContent.duration || currentContent.content.duration) - state.timeSpent;
        if (currentlyAvailableTimeSpent <= 0) {
            return;
        }
        state.timeSpent += Math.min(timeSpent, currentlyAvailableTimeSpent);
        state.updatedAt = state.lastUpdatedTimeSpent = timeStamp;
        const contentType = getContentType_1.getContentType(currentContent);
        const { companyId } = user;
        if (timeSpent > 0) {
            const timeSpentEvent = getTimeSpentEvent_1.getTimeSpentEvent(command, companyId, userId, contentId, contentType, timeSpent);
            events.push(timeSpentEvent);
        }
    });
    return { states: updatedStates, events, stateInteractions: [], enrolments: [] };
}
exports.applyAddTimeCommand = applyAddTimeCommand;
//# sourceMappingURL=applyAddTimeCommand.js.map